import { Flex, Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n/LanguageContext';
import { buildPageUrl } from '../lib/seo/constants';

export default function Breadcrumbs({ items }) {
  const { lang, t } = useTranslation();

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      ...(item.path ? { item: buildPageUrl(lang, item.path) } : {}),
    })),
  };

  return (
    <Flex
      as="nav"
      aria-label={t('breadcrumbs.aria')}
      alignItems="center"
      gap={2}
      fontSize="13px"
      color="text.medium.grey"
      width="100%"
      maxW="1280px"
      px="20px"
      pt="12px"
    >
      <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      {items.map((item, index) => (
        <Flex key={item.label} alignItems="center" gap={2}>
          {index > 0 && <Text aria-hidden="true">/</Text>}
          {item.path ? (
            <Link to={item.path}>
              <Text _hover={{ color: 'fill.coral' }}>{item.label}</Text>
            </Link>
          ) : (
            <Text color="text.dark.grey" aria-current="page">
              {item.label}
            </Text>
          )}
        </Flex>
      ))}
    </Flex>
  );
}
